<template>
  <div class="page border-box" v-wechat-title="$route.meta.title='AR体验激活'">
    <div class="page-bg-box">
      <img src="../../assets/ar/bg.png" alt="" class="page-bg">
    </div>
    <img src="../../assets/ar/top-bg.png" alt="" class="top-bg">
    <div class="con">
      <div class="cod-inp box">
        <div class="flex border-box">
          <input type="text" placeholder="请输入20位激活码" v-model='OTAcode'>
        </div>
        <img src="../../assets/ar/btn-jh.png" alt="" class="jh-btn"  :class="count>0?'':'opt66'" @click="activeATO">
        <!--<div class="tip tip-cor" v-if="tipShow==1">无效的激活码！请仔细核对后重新输入！</div>-->
        <div class="tip tip-cor" v-if="tipShow==1">{{codeTip}}</div>
      </div>
      <div class="btn-box clearfix" :class="count>0?'':'opt66'">
        <img class="fl" src="../../assets/ar/btn1.png" alt="" @click="toTY">
        <img class="fr" src="../../assets/ar/btn2.png" alt="" @click="toJH">
      </div>
    </div>
    <img src="../../assets/ar/logo.png" alt="" class="logo">
    <div class="footer">版权所有-成都网传文化传播有限公司</div>
  </div>

</template>

<script>
  import {arUserIsActive,activeOTAcode} from "@/service/getData";
  import { mapState, mapMutations } from 'vuex'
  import {setStore, getStore, removeStore} from '@/config/mUtils'
  import {wxShareme} from '@/utils/wechat'
  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return{
        count:'',//用户是否已经激活过
        tipShow:0,
        codeTip:'',//输入框提示
        OTAcode:''
      }
    },
    computed: {},
    created() {
      this.userInfo = getStore("userInfo");
      this.arUserIsActiveFun();
    },
    methods: {
      //获取用户是否已经激活过
      async arUserIsActiveFun(){
        let res = await arUserIsActive({
          openid: this.userInfo.openid
        });
        if (res.errcode === "00000"){
          this.count = res.data.count;
          let title = '金牌解说 | AR体验激活';
          let desc = '金牌解说AR数字文创';
          let img = 'https://filewc.geeker.com.cn/jpjs/upload/default/share-ar.jpg';
          let link = '/ar-active';
          wxShareme(title,desc,img,link);
        }
      },

      //立即激活
      async activeATO(){
        if(this.OTAcode=='' || this.OTAcode==null || this.OTAcode==undefined){
          this.$toast('请输入获得的激活码');
          return
        }
        var self = this;
        let res = await activeOTAcode({
          openid: this.userInfo.openid,
          code: this.OTAcode,
          pid:100
        });
        if (res.errcode == '00000') {
          this.$toast('激活成功');
          this.arUserIsActiveFun();

        }else {
          this.$alert({
            title: '提示',
            content: res.errmsg,
          });
        }
      },
      toTY(){
        if(this.count>0){
          this.$router.push({
            path: `/ar-list-ty`
          });
        }else{
          this.$toast('请先输入激活码激活');
        }
      },
      toJH(){
        if(this.count>0){
          this.$router.push({
            path: `/ar-list-jh`
          });
        }else{
          this.$toast('请先输入激活码激活');
        }
      },
    },
    components: {

    },

  }

</script>

<style scoped>
  .opt66{opacity: .66;}
  .tip-cor{color: #f24b3f;}
  .page{width: 100vw;height: 100vh;background-color:#f8e6d5;overflow: hidden;}
  .logo{position: absolute;bottom:1rem;left: 36vw;width: 28vw;height: auto;}
  .footer{position: absolute;bottom: .52rem;left: 0;width:100%;text-align:center;font-size: .22rem;color: #a2a2a2;}
  .page-bg-box{position: absolute;top:0;left: 0;width: 100%;height: 100%;overflow: hidden;}
  .page-bg{width: 100%;height: auto;}
  .top-bg{position: absolute;top:.75rem;left: 8%;width: 84%;height: auto;}
  .con{position: absolute;left: 10%;top:46%;width: 80%;height: auto;}
  .cod-inp{position:relative;display: block;width: 100%;height:1rem;margin: 0 auto;background: url(../../assets/ar/inp-bg.png) no-repeat center;background-size: 100% 100%;}
  .tip{position: absolute;width: 100%;top: 1.05rem;left: 4%;font-size: .22rem;}
  .cod-inp .flex{padding: .1rem .32rem .2rem;}
  .cod-inp .flex input{float: left;width: 100%;height: 100%;font: bold .32rem/.7rem "Microsoft YaHei";color: #a34f03;}
  .jh-btn{width: 1.34rem;height: .72rem;margin-right: .1rem;margin-top: .1rem;}
  .btn-box{width: 100%;margin-top: .46rem;}
  .btn-box img{width: 46.66%;height: auto;}
</style>



// WEBPACK FOOTER //
// src/page/ar/ar-active.vue